import statuses from '@/store/statuses';
import mutations from './mutations';
import actions from './actions';

const defaultState = () => {
  return {
    auditLogsList: {
      data: [],
      status: statuses.EMPTY,
    },
  };
};

const AuditLogs = {
  namespaced: true,
  state: defaultState,
  getters: {
    auditLogsList: (state) => state.auditLogsList,
  },
  mutations,
  actions,
};

export { AuditLogs, defaultState };
